// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cR9zhnbdhgknlC {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--ds-space-200, 16px) var(--ds-space-300, 24px);
  background-color: var(--ds-background-neutral-bold, #44546f);
  color: var(--ds-text-inverse, #ffffff);
}
.TeYZ5IBxW09c5b {
  position: relative;
  text-align: center;
}
.uGKeC9z9o2V8BW {
  position: relative;
  top: var(--ds-space-025, 2px);
  margin: var(--ds-space-050, 4px) var(--ds-space-100, 8px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `cR9zhnbdhgknlC`,
	"text": `TeYZ5IBxW09c5b`,
	"icon": `uGKeC9z9o2V8BW`
};
export default ___CSS_LOADER_EXPORT___;
